import { createContext, useContext } from 'react';

const noop = () => undefined;

export const TourAutoOpenCancellationContext = createContext<() => void>(noop);

export const useCancelTourAutoOpen = (): (() => void) =>
  useContext(TourAutoOpenCancellationContext);
